import BookOutlinedIcon from '@mui/icons-material/BookOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import MiscellaneousServicesOutlinedIcon from '@mui/icons-material/MiscellaneousServicesOutlined';
import Icons from "../../constants/Icons";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
const routes = [
    {
        path: "/en",
        nameEn: "Home",
        nameAr: "الرئيسية",
        icon: <Icons.Home className="logoSvg" style={{ width: 20 }} />,
        icon2: <HomeOutlinedIcon fontSize="small" sx={{ color: '#fff' }} />
    },
    {
        path: "/en/about-us",
        nameEn: "About Us",
        nameAr: "من نحــن ",
        icon: <Icons.Aboutus className="logoSvg" style={{ width: 20 }} />, 
        icon2: <InfoOutlinedIcon fontSize="small" sx={{ color: '#fff' }} />

    },

    {
        path: "/en/projects",
        nameEn: "Portfolio",
        nameAr: "أعمالنا",
        icon: <Icons.Projects className="logoSvg" style={{ width: 20 }} />,
        icon2: <AccountTreeOutlinedIcon fontSize="small" sx={{ color: '#fff' }} />

    },
    {
        path: "/en/service",
        nameEn: "Service",
        nameAr: "خدماتنا ",
        icon: <Icons.Service className="logoSvg" style={{ width: 20 }} />,
        icon2: <MiscellaneousServicesOutlinedIcon fontSize="small" sx={{ color: '#fff' }} />,
        subRoutes: [
            {
                path: "/en/service/Digital-Marketing",
                nameEn: "Digital marketing",
                nameAr: "التسويق الرقمي "
            },
            {
                path: "/en/service/Web-Development",
                nameEn: "Website development",
                nameAr: "تطوير المواقع"
            },
            {
                path: "/en/service/Internal-Communication-And-Events",
                nameEn: " Events",
                nameAr: "الاتصالات الداخلية والأحداث"
            },
            {
                path: "/en/service/Visual-Production",
                nameEn: "Visual Production",
                nameAr: "الإنتاج المرئي"
            },
            {
                path: "/en/service/Socia-Media-Management",
                nameEn: "Socia Media Management",
                nameAr: "إدارة وسائل التواصل الاجتماعي"
            },
            {
                path: "/en/service/Branding",
                nameEn: "Branding",
                nameAr: "العلامة التجارية"
            },
        ]
    },
    // {
    //     path: "/jobs",
    //     nameEn: "jobs",
    //     icon: <Icons.Aboutus className="logoSvg" style={{ width: 20 }} />,
    // },

    {
        path: "/en/clients",
        nameEn: "Our Clients",
        nameAr: "عملائنا",
        icon: <Icons.Clients className="logoSvg" style={{ width: 20 }} />,
        icon2: <GroupOutlinedIcon fontSize="small" sx={{ color: '#fff' }} />

    },

    {
        path: "/en/blogs",
        nameEn: "Blogs",
        nameAr: "مقالات",
        icon: <Icons.Blogs className="logoSvg" style={{ width: 20 }} />,
        icon2: <BookOutlinedIcon fontSize="small" sx={{ color: '#fff' }} />

    },
    {
        path: "/en/jobs",
        nameEn: "Jobs",
        nameAr: "الوظائف ",
        icon: <Icons.Jops className="logoSvg" style={{ width: 20 }} />,
        icon2: <BusinessCenterOutlinedIcon fontSize="small" sx={{ color: '#fff' }} />

    },
    {
        path: "/en/contactus",
        nameEn: "Contact Us",
        nameAr: "أتصل بنا ",
        icon: <Icons.ContactUs className="logoSvg" style={{ width: 20 }} />,
        icon2: <CallOutlinedIcon fontSize="small" sx={{ color: '#fff' }} />

    },

];

export default routes